import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const CURRENT_USER_REWARDS_REQUEST = 'CURRENT_USER_REWARDS_REQUEST';
export const CURRENT_USER_REWARDS_RESPONSE = 'CURRENT_USER_REWARDS_RESPONSE';

export function currentUserRewardsRequest() {
  return {
    type: CURRENT_USER_REWARDS_REQUEST,
  };
}

export function currentUserRewardsResponse(rewards) {
  return {
    type: CURRENT_USER_REWARDS_RESPONSE,
    rewards,
  };
}

export function getCurrentUserRewards() {
  return dispatch => {
    dispatch(currentUserRewardsRequest());
    Promise.all([fetchAllAvailableRewards(), fetchCurrentUserRewards()]).then(response => {
      const allAvailableRewards = response[0];
      const currentUserRewards = response[1];
      const rewards = allAvailableRewards.map(reward => {
        reward.enabled = isEnabledReward(currentUserRewards, reward);
        return reward;
      });
      dispatch(currentUserRewardsResponse(rewards));
    });
  };
}

export function addCurrentUserRewardAndUpdate(gameType) {
  return dispatch => {
    addRewardToCurrentPcBang(gameType).then(() => dispatch(getCurrentUserRewards()));
  };
}

export function deleteCurrentUserRewardAndUpdate(gameType) {
  return dispatch => {
    deleteRewardToCurrentPcBang(gameType).then(() => dispatch(getCurrentUserRewards()));
  };
}

const isEnabledReward = (currentUserRewards, rewardToCheck) => {
  let enabledOrNot = false;
  currentUserRewards.forEach(reward => {
    if (reward.rewardId === rewardToCheck.rewardId) {
      enabledOrNot = true;
    }
  });
  return enabledOrNot;
};

const fetchAllAvailableRewards = () =>
  fetch(`${API_URL}/loyalty-admin/rewards`, {
    method: 'GET',
    headers: commonHeaders(),
  })
    .then(commonErrorHandler)
    .then(response => response.json());

const fetchCurrentUserRewards = () =>
  fetch(`${API_URL}/users/current-user/rewards`, {
    method: 'GET',
    headers: commonHeaders(),
  })
    .then(commonErrorHandler)
    .then(response => response.json());

const addRewardToCurrentPcBang = gameType => {
  return fetch(`${API_URL}/users/current-user/rewards/${gameType}`, {
    method: 'PUT',
    headers: commonHeaders(),
  }).then(commonErrorHandler);
};

const deleteRewardToCurrentPcBang = gameType =>
  fetch(`${API_URL}/users/current-user/rewards/${gameType}`, {
    method: 'DELETE',
    headers: commonHeaders(),
  }).then(commonErrorHandler);
